"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_native_paper_1 = require("react-native-paper");
const communicationSlice_1 = require("./communicationSlice");
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const styles_1 = __importDefault(require("../../styles/styles"));
const communicationBoxConstants_1 = require("./communicationBoxConstants");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const analytics_1 = require("../../utils/analytics");
const eventConstants_1 = require("../../constants/eventConstants");
const communicationBoxUtils_1 = require("./communicationBoxUtils");
const browserNotification_1 = __importDefault(require("../browserNotification/browserNotification"));
const typesConstants_1 = require("../../constants/typesConstants");
const constants_1 = require("../../constants/constants");
const callConfirmed_1 = __importDefault(require("./voipCall/callConfirmed/callConfirmed"));
const inBoundCall_1 = __importDefault(require("./voipCall/callConnecting/inBoundCall"));
const phoneNumberField_1 = __importDefault(require("../input/phoneNumberField"));
const communicationBoxDropdown_1 = __importDefault(require("./communicationBoxDropdown/communicationBoxDropdown"));
const button_1 = __importDefault(require("../button/button"));
const authSlice_1 = require("../../features/auth/authSlice");
const callConstant_1 = require("../../features/call/callConstant");
const callConnecting_1 = __importDefault(require("./voipCall/callConnecting/callConnecting"));
const callFailed_1 = __importDefault(require("./voipCall/callFailed/callFailed"));
const callEnded_1 = __importDefault(require("./voipCall/callEnded/callEnded"));
const utils_1 = require("../../utils/utils");
const actionsLoadingComponent_1 = __importDefault(require("../actionsLoadingComponent/actionsLoadingComponent"));
const callFeedback_1 = __importDefault(require("./callFeedback/callFeedback"));
const callFeedBackConstants_1 = require("./callFeedback/callFeedBackConstants");
const scheduleSlice_1 = require("../../features/schedules/scheduleSlice");
const actionsSlice_1 = require("../../features/actions/actionsSlice");
const colors_1 = __importDefault(require("../../styles/colors"));
const boxTitleStyles_1 = __importDefault(require("../boxTitle/boxTitleStyles"));
const callLog_1 = __importDefault(require("../callLog/callLog"));
const ringingTone = require('../../assets/audio/tone.ogg');
const defaultProps = {
    collapsible: false,
};
const QueueCommunicationBox = ({ collapsible }) => {
    const { ua, voipUserId, voipPassword, callStatus, officerFirstName, callerInbound, officerStatus, voipProviders, isValidPhoneNumber, currentVoipProvider, officerType, phoneNumber, loan, schedule, customer, } = useAppSelector_1.default((state) => ({
        ua: state.communication.ua,
        voipUserId: state.auth.user.voip_user_id,
        voipPassword: state.auth.user.voip_password,
        callStatus: state.communication.voipCallStatus,
        isValidPhoneNumber: state.communication.isValidPhoneNumber,
        callerInbound: state.communication.callerInbound,
        phoneNumber: state.communication.phoneNumber,
        officerFirstName: state.auth.user.first_name,
        officerStatus: state.officers.status,
        currentVoipProvider: state.auth.user.current_voip_provider,
        voipProviders: state.auth.user.voip_providers,
        officerType: state.auth.user.officer_type,
        loan: state.schedule.loan,
        schedule: state.schedule.schedule,
        customer: state.support.customer,
    }));
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_1);
    const greeting = `Hi ${officerFirstName}`;
    const contact = communicationBoxUtils_1.parseInboundContact(callerInbound);
    const scheduleId = schedule && schedule.id;
    const officerIsPaused = officerStatus === constants_1.OFFICER_STATUS_PAUSED;
    const dispatch = useAppDispatch_1.default();
    const [session, setSession] = react_1.useState(null);
    const remoteAudio = react_1.useRef(null);
    const [callDirection, setCallDirection] = react_1.useState(communicationBoxConstants_1.INCOMING_CALL);
    const audioComponent = (react_1.default.createElement("audio", { ref: remoteAudio },
        react_1.default.createElement("track", { kind: "captions", label: contact || 'ringing' })));
    const [startDatetime, setStartDatetime] = react_1.useState(null);
    const [endDatetime, setEndDatetime] = react_1.useState(null);
    const [isMutedState, setIsMutedState] = react_1.useState(false);
    const [isOnHold, setIsOnHold] = react_1.useState(false);
    const [connectVoipServer, setConnectVoipServer] = react_1.useState(true);
    const [boxLabel, setBoxLabel] = react_1.useState(`${greeting}, ${communicationBoxConstants_1.TRYING_TO_CONNECT}`);
    const [notificationMessage, setNotificationMessage] = react_1.useState(null);
    const [callFailedMessage, setCallFailedMessage] = react_1.useState('');
    const [selectedContact, setSelectedContact] = react_1.useState(null);
    const [displayFeedback, setDisplayFeedback] = react_1.useState(false);
    const [showOutBoundCall, setShowOutBoundCall] = react_1.useState(false);
    const [showCallLogs, setShowCallLogs] = react_1.useState(false);
    const [connectionStatusColor, setConnectionStatusColor] = react_1.useState(colors_1.default.RED);
    const idleState = [communicationBoxConstants_1.IDLE, communicationBoxConstants_1.FAILED, communicationBoxConstants_1.ENDED];
    // Get and set the officer asterisk call extension.
    const prefix = callConstant_1.EXTENSIONS.get(officerType) || callConstant_1.CREDIT_COLLECTIONS;
    const callContext = `${prefix}#${phoneNumber}#${currentVoipProvider.asterisk_value}#`;
    const automatedAnswer = typesConstants_1.AUTOMATED_ANSWER_OFFICER_TYPES.includes(officerType);
    react_1.useEffect(() => {
        // Create a new websocket connection on mount
        dispatch(communicationSlice_1.newUAConnection({ voipUserId, voipPassword }));
        // Fetch ringing tone once.
        remoteAudio.current = new Audio(ringingTone);
        return () => {
            dispatch(communicationSlice_1.resetUAState);
        };
    }, []);
    react_1.useEffect(() => {
        if (customer) {
            // Set contact person to the user if it exist.
            setSelectedContact(customer);
            return;
        }
        // Set contact person if a loan exist
        if (!loan) {
            // close feedback (if open)
            setDisplayFeedback(false);
            return;
        }
        const borrower = loan.borrowers[0]; // get borrower from the borrowers list
        // Build a CallablePerson from shared BaseBorrower fields so both Borrower and
        // InternalBorrower are handled safely without relying on their divergent shapes.
        const baseContact = {
            available_sms: borrower.available_sms,
            first_name: borrower.first_name,
            last_name: borrower.last_name,
            phone_number: borrower.phone_number,
            email: borrower.email,
            do_not_call: borrower.do_not_call,
        };
        // Update phone number to current valid inbound number if it is available and different.
        const borrowerContact = !communicationBoxUtils_1.validatePhoneNumber(contact)
            ? { ...baseContact, phone_number: contact }
            : baseContact;
        setDisplayFeedback(true);
        setSelectedContact(borrowerContact);
    }, [loan, customer]);
    react_1.useEffect(() => {
        if (!contact || callDirection === communicationBoxConstants_1.OUTGOING_CALL)
            return;
        // Always display notification for inbound calls.
        if (callStatus === communicationBoxConstants_1.CONNECTING) {
            setNotificationMessage({
                title: 'Inbound Call',
                tag: contact,
                body: `You have an inbound call from ${contact}`,
            });
            return;
        }
        setNotificationMessage(null);
    }, [contact, callStatus]);
    const setCallStatus = (status) => {
        dispatch(communicationSlice_1.updateCallStatus({ status }));
    };
    const muteCallHandler = (isMuted) => {
        const action = isMuted ? 'mute' : 'unmute';
        session[action]();
        setIsMutedState(isMuted);
    };
    const holdCallHandler = (isHold) => {
        const action = isHold ? 'hold' : 'unhold';
        const success = session[action]();
        if (success) {
            const actionPlay = isHold ? 'pause' : 'play';
            remoteAudio.current[actionPlay]();
            setIsOnHold(isHold);
        }
    };
    const endIncomingCallHandler = () => {
        dispatch(communicationSlice_1.updateCallerInbound({ callerInbound: '' }));
        if (session) {
            session.terminate();
            setSession(null);
        }
        if (remoteAudio.current)
            remoteAudio.current.pause();
        setBoxLabel(communicationBoxConstants_1.AWAITING_CALLS);
        setConnectionStatusColor(colors_1.default.BLUE);
        setCallStatus(communicationBoxConstants_1.IDLE);
    };
    const endCallHandler = () => {
        ua.terminateSessions();
    };
    const closeVoipConnection = () => {
        // End current voip websocket connection
        ua.stop();
        if (connectVoipServer) {
            // Prevent creating a new connection on call disconnection.
            setConnectVoipServer(false);
        }
        // set a new connection in state
        dispatch(communicationSlice_1.newUAConnection({ voipUserId, voipPassword }));
    };
    const answerCallHandler = () => {
        if (!session)
            return;
        setStartDatetime(new Date());
        setCallStatus(communicationBoxConstants_1.CONFIRMED);
        session.answer(communicationBoxConstants_1.MEDIA_CONSTRAINTS);
    };
    const onDroppedCall = (ringingStartTime, caller_id) => {
        const scheduleUUID = communicationBoxUtils_1.parseInboundUUID(caller_id);
        // Stop here if the schedule id is not valid
        if (!scheduleUUID)
            return;
        const payload = {
            scheduleId: scheduleUUID,
            recipient_name: 'user',
            recipient_phone_number: communicationBoxUtils_1.parseInboundContact(caller_id),
            duration: utils_1.getTimeUsed(ringingStartTime, new Date()),
        };
        dispatch(actionsSlice_1.notifyDroppedCall(payload));
        dispatch(scheduleSlice_1.resetScheduleState());
    };
    const options = {
        eventHandlers: {
            progress() {
                analytics_1.logEvent(eventConstants_1.CONNECTING_HANDLER);
                setCallStatus(communicationBoxConstants_1.CONNECTING);
            },
            failed(e) {
                analytics_1.logEvent(eventConstants_1.FAILED_HANDLER);
                setCallStatus(communicationBoxConstants_1.FAILED);
                setCallFailedMessage(e.cause);
            },
            ended() {
                analytics_1.logEvent(eventConstants_1.ENDED_HANDLER);
                setEndDatetime(new Date());
                setCallStatus(communicationBoxConstants_1.ENDED);
            },
            confirmed() {
                analytics_1.logEvent(eventConstants_1.CONFIRMED_HANDLER);
                setStartDatetime(new Date());
                setCallStatus(communicationBoxConstants_1.CONFIRMED);
            },
        },
        ...communicationBoxConstants_1.MEDIA_CONSTRAINTS,
    };
    const dialHandler = () => {
        setCallDirection(communicationBoxConstants_1.OUTGOING_CALL);
        setSession(ua.call(callContext, options));
    };
    const startUAConnection = () => {
        ua.start();
        ua.on('connected', () => {
            setBoxLabel(`${greeting}, ${communicationBoxConstants_1.CONNECTED_TO_SERVER}`);
            setConnectionStatusColor(colors_1.default.BLUE);
            analytics_1.logEvent(eventConstants_1.UA_CONNECTED);
        });
        ua.on('newRTCSession', (e) => {
            if (e.originator === communicationBoxConstants_1.INCOMING_CALL) {
                const ringingStartTime = new Date();
                setCallDirection(communicationBoxConstants_1.INCOMING_CALL);
                const incomingCallContact = e.request.from.toString();
                dispatch(communicationSlice_1.updateCallerInbound({ callerInbound: incomingCallContact }));
                setCallStatus(communicationBoxConstants_1.CONNECTING);
                setSession(e.session);
                e.session.on('failed', () => {
                    onDroppedCall(ringingStartTime, incomingCallContact);
                    endIncomingCallHandler();
                });
                e.session.on('ended', () => {
                    endIncomingCallHandler();
                });
                if (remoteAudio.current) {
                    remoteAudio.current.srcObject = null;
                    remoteAudio.current.currentTime = 0;
                    remoteAudio.current.loop = true;
                    remoteAudio.current.play();
                }
            }
        });
        ua.on('disconnected', (e) => {
            analytics_1.logEvent(eventConstants_1.UA_DISCONNECTED);
            // Only display disconnect error page, if the disconnection is as a result of an error.
            if (e.error) {
                setBoxLabel(`${greeting}, ${communicationBoxConstants_1.CONNECTION_FAILED}`);
                setCallStatus(communicationBoxConstants_1.DISCONNECTED);
                setConnectionStatusColor(colors_1.default.RED);
                closeVoipConnection();
            }
        });
    };
    react_1.useEffect(() => {
        // Control connection to asterisk depending on the officer status.
        if (officerIsPaused) {
            // Close active connection (if any) when officer is paused.
            if (ua) {
                ua.stop();
            }
            setBoxLabel(`${greeting}, ${communicationBoxConstants_1.PAUSE_TIME}`);
            setConnectVoipServer(false);
            setConnectionStatusColor(colors_1.default.RED);
        }
        else {
            // Connect officer to asterisk.
            setBoxLabel(`${greeting}, ${communicationBoxConstants_1.TRYING_TO_CONNECT}`);
            setConnectionStatusColor(colors_1.default.RED);
            setConnectVoipServer(true);
        }
    }, [officerIsPaused]);
    react_1.useEffect(() => {
        const handleStart = () => {
            // Only connect to asterisk if ua is set.
            if (!(ua && connectVoipServer))
                return;
            startUAConnection();
        };
        handleStart();
        return () => {
            // Clean up. Stop active connection on unmount.
            if (ua)
                ua.stop();
        };
    }, [ua, connectVoipServer]);
    react_1.useEffect(() => {
        // useEffect hook responsible for handling call sessions (answering of calls and setting the audio).
        if (!session)
            return; // Stop if no active session
        if (session.connection) {
            // Add event listener to handle incoming tracks(audio).
            session.connection.addEventListener('track', (e) => {
                analytics_1.logEvent(eventConstants_1.SET_TRACK_STREAM); // Log the event of setting track stream.
                // Set remote audio stream.
                const { 0: stream } = e.streams;
                remoteAudio.current.srcObject = stream;
                // Add event listener to play audio when it can play.
                remoteAudio.current.addEventListener('canplay', () => {
                    remoteAudio.current.play();
                }, { once: true });
            });
        }
        else if (callStatus === communicationBoxConstants_1.CONNECTING && callDirection === communicationBoxConstants_1.INCOMING_CALL && automatedAnswer) {
            answerCallHandler();
        }
    }, [session, session && session.connection]);
    let content;
    if (callStatus === communicationBoxConstants_1.CONNECTING) {
        content =
            callDirection === communicationBoxConstants_1.INCOMING_CALL ? (react_1.default.createElement(inBoundCall_1.default, { endCall: endIncomingCallHandler, contact: contact, startCall: answerCallHandler })) : (react_1.default.createElement(callConnecting_1.default, { endCall: endCallHandler }));
    }
    else if (callStatus === communicationBoxConstants_1.CONFIRMED) {
        content = (react_1.default.createElement(callConfirmed_1.default, { isMuted: isMutedState, isOnHold: isOnHold, muteCallHandler: muteCallHandler, holdCallHandler: holdCallHandler, contact: contact, endCall: endCallHandler, startDatetime: startDatetime }));
    }
    else if (callStatus === communicationBoxConstants_1.DISCONNECTED) {
        content = (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                react_1.default.createElement(boxTitle_1.default, { title: communicationBoxConstants_1.CONNECTION_ERROR }))));
        // Show PhoneNumberField only when idle.
        // If collapsible is enabled, also ensure showOutBoundCall is true.
    }
    else if (callStatus === communicationBoxConstants_1.IDLE && (!collapsible || showOutBoundCall)) {
        content = react_1.default.createElement(phoneNumberField_1.default, null);
    }
    else if (callStatus === communicationBoxConstants_1.FAILED) {
        content = (react_1.default.createElement(callFailed_1.default, { redialHandler: () => setCallStatus(communicationBoxConstants_1.IDLE), text: "Back", icon: free_solid_svg_icons_1.faArrowLeft, callFailedMessage: callFailedMessage }));
    }
    else if (callStatus === communicationBoxConstants_1.ENDED) {
        content = (react_1.default.createElement(callEnded_1.default, { duration: utils_1.getTimeUsed(startDatetime, endDatetime), redialHandler: () => setCallStatus(communicationBoxConstants_1.IDLE) }));
    }
    const updateVoipCallProvider = (provider) => {
        dispatch(authSlice_1.updateVoipProvider({ backend_value: provider }));
    };
    const minHeightStyle = isDesktop ? styles_1.default.minHeight : { minHeight: 340 };
    const buttonContainerStyles = isDesktop ? [styles_1.default.flexDirectionRow, styles_1.default.flexOne] : [];
    let viewContent;
    if (collapsible) {
        viewContent = (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, { minHeight: 100 }] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexOne] },
                react_1.default.createElement(react_native_1.View, { style: [
                        isDesktop ? styles_1.default.flexDirectionRow : styles_1.default.flexDirectionColumn,
                        styles_1.default.flexThree,
                    ] },
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexTwo] },
                        react_1.default.createElement(react_native_paper_1.Title, { style: [boxTitleStyles_1.default.text, { color: connectionStatusColor }] }, boxLabel)),
                    react_1.default.createElement(react_native_1.View, { style: [
                            buttonContainerStyles,
                            styles_1.default.marginTopTen,
                            styles_1.default.alignCenterEnd,
                            styles_1.default.flexOne,
                        ] },
                        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.button] },
                            react_1.default.createElement(button_1.default, { fill: showOutBoundCall, text: showOutBoundCall ? 'Hide Phone Call' : 'Make Phone Call', icon: free_solid_svg_icons_1.faPhoneVolume, onPress: () => setShowOutBoundCall(!showOutBoundCall), eventName: eventConstants_1.TOGGLE_OUTBOUND_CALL, disabled: callStatus === communicationBoxConstants_1.DISCONNECTED })),
                        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.button] },
                            react_1.default.createElement(button_1.default, { fill: showCallLogs, text: showCallLogs ? 'Hide Call Logs' : 'Show Call Logs', icon: free_solid_svg_icons_1.faMobilePhone, onPress: () => setShowCallLogs(!showCallLogs), eventName: eventConstants_1.TOGGLE_CALL_LOGS }))),
                    react_1.default.createElement(communicationBoxDropdown_1.default, { voipCallProviders: voipProviders, action: updateVoipCallProvider }))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginTopTen] }, content),
            idleState.includes(callStatus) && showOutBoundCall && (react_1.default.createElement(react_native_1.View, { style: buttonContainerStyles },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen, styles_1.default.button] },
                    react_1.default.createElement(button_1.default, { fill: true, text: "Call", icon: free_solid_svg_icons_1.faPhone, onPress: dialHandler, eventName: eventConstants_1.VOIP_CALL_BUTTON, disabled: !isValidPhoneNumber })))),
            showCallLogs && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTopTen },
                react_1.default.createElement(react_native_paper_1.Title, { style: [
                        styles_1.default.textColorBlack,
                        styles_1.default.marginBottomTen,
                        styles_1.default.fontWeightBold,
                    ] }, `Call Log `),
                react_1.default.createElement(callLog_1.default, null)))));
    }
    else {
        viewContent = (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, minHeightStyle] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexFour] },
                    react_1.default.createElement(react_native_paper_1.Title, { style: [boxTitleStyles_1.default.text, { color: connectionStatusColor }] }, boxLabel)),
                react_1.default.createElement(communicationBoxDropdown_1.default, { voipCallProviders: voipProviders, action: updateVoipCallProvider })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginTopTen] }, content),
            idleState.includes(callStatus) && (react_1.default.createElement(react_native_1.View, { style: buttonContainerStyles },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen, styles_1.default.button] },
                    react_1.default.createElement(button_1.default, { fill: true, text: "Call", icon: free_solid_svg_icons_1.faPhone, onPress: dialHandler, eventName: eventConstants_1.VOIP_CALL_BUTTON, disabled: !isValidPhoneNumber })))),
            displayFeedback && !!selectedContact && !!scheduleId && (react_1.default.createElement(actionsLoadingComponent_1.default, { actionType: typesConstants_1.LOG_CALL_ACTION_TYPE },
                react_1.default.createElement(callFeedback_1.default, { setBaseContent: () => setDisplayFeedback(false), selectedContact: selectedContact, callType: communicationBoxConstants_1.CALL_TYPE_VOIP, duration: startDatetime && endDatetime
                        ? utils_1.getTimeUsed(startDatetime, endDatetime)
                        : callFeedBackConstants_1.TIMER_START_VALUE, provider: currentVoipProvider, sipData: null, disableSaveButton: false })))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        audioComponent,
        viewContent,
        react_1.default.createElement(browserNotification_1.default, { message: notificationMessage })));
};
QueueCommunicationBox.defaultProps = defaultProps;
exports.default = QueueCommunicationBox;
